import { DEVICE } from '../../../../enum/device';
import { TEST_TYPE } from '../../../../enum/test-type';
import { TEST_STAGE } from '../../../../enum/testStage.enum';

export class ThreeDScanIvueOctTest {
    public readonly type: TEST_TYPE = TEST_TYPE.THREED_SCAN;
    public readonly device: DEVICE = DEVICE.IVUE_OCT;
    public readonly name: string = '3D Scan';
    public stage: TEST_STAGE;
}
